<template>
	<div class="card-specimen">
		<img
			@click="showImageSpecimen(specimen)"
			onerror="this.src='/rooster/rooster.jpg'"
			v-if="specimen.thumb"
			class="image-specimen-tree cursor-pointer"
			:src="specimen.thumb"
			alt=""
		/>

		<p @click="linkSpecimen(specimen.id)" class="alias cursor-pointer" style="">
			{{ specimen.plate ? specimen.plate : "Sin alias" }}
		</p>

		<div class="d-flex align-items-center container-text-tree">
			<img
				class="img-icon-specimen"
				style="width: 20px; height: 20px"
				src="data:image/svg+xml;base64,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"
			/>

			<p class="mb-0" style="color: #a0a0a0; font-weight: 300; font-size: 15px">
				{{ specimen.alias ? specimen.alias : "---" }}
			</p>
		</div>

		<!-- <div class="d-flex align-items-center container-text-tree">
			<img
				class="img-icon-specimen"
				style="width: 20px; height: 20px"
				src="data:image/svg+xml;base64,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"
			/>
			<p class="mb-0" style="color: #a0a0a0; font-weight: 300; font-size: 15px">
				{{ specimen.date ? specimen.date : "---" }}
			</p>
		</div> -->

		<div
			class="d-flex align-items-center container-text-tree"
			v-b-tooltip.hover="`Posturas Activas`"
			v-if="specimen.category_id == 1"
		>
			<span class="mr-05 font-weight-bolder">PA</span>
			<p class="mb-0" style="color: #a0a0a0; font-weight: 300; font-size: 15px">{{ specimen.p_act }}</p>
		</div>
		<div class="d-flex align-items-center container-text-tree" v-b-tooltip.hover="`Hijos Vivos por Temporada`">
			<span class="mr-05 font-weight-bolder">HV</span>
			<p class="mb-0" style="color: #a0a0a0; font-weight: 300; font-size: 15px">{{ specimen.chicks_alive }}</p>
		</div>
		<div class="d-flex align-items-center container-text-tree" v-b-tooltip.hover="`Fertilidad Acumulada`">
			<span class="mr-05 font-weight-bolder">FA</span>
			<p class="mb-0" style="color: #a0a0a0; font-weight: 300; font-size: 15px">
				{{ Number(specimen.fertilidad).toFixed(2) }}%
			</p>
		</div>

		<div class="container-cintillos" v-if="specimen.category_id == 2">
			<div
				class="cintillo"
				v-if="specimen.qty_cintillos == 1 || specimen.qty_cintillos == 2"
				:style="{ background: specimen.color }"
			>
				<span>{{ specimen.pata == 1 || specimen.pata == 3 ? "I" : "D" }}</span>
			</div>
			<div class="cintillo" v-if="specimen.qty_cintillos > 1" :style="{ background: specimen.color_secondary }">
				<span>{{ specimen.pata == 1 || specimen.pata == 3 ? "I" : "D" }}</span>
			</div>
		</div>

		<div class="line" :class="[specimen.category_id == 2 ? 'line-madrilla' : '']"></div>

		<SlidersImageVideo
			:url="imageSpecimen.url"
			:type="imageSpecimen.type"
			:text="imageSpecimen.text"
			:text_url="imageSpecimen.text_url"
			:open="imageSpecimen.open"
			:idSpecimen="imageSpecimen.specimen_id"
			v-if="imageSpecimen.open"
			@refreshSlider="refresh"
		/>
	</div>
</template>

<script>
import SlidersImageVideo from "@/views/amg/header-bookmarks/SlidersImageVideo.vue"

export default {
	name: "CardSpecimenTree",
	components: {
		SlidersImageVideo,
	},
	props: {
		specimen: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			isLoaded: false,
			imageSpecimen: {
				url: null,
				type: null,
				text: null,
				text_url: null,
				open: false,
				specimen_id: null,
			},
		}
	},
	methods: {
		linkSpecimen(id) {
			window.open(`/ejemplares/detalle/${id}`, "_blank")
		},
		refresh() {
			this.imageSpecimen.open = false
			this.imageSpecimen.text_url = null
			this.imageSpecimen.type = null
			this.imageSpecimen.text = null
			this.imageSpecimen.url = null
			this.imageSpecimen.specimen_id = null
		},
		showImageSpecimen(item) {
			this.imageSpecimen.open = true
			this.imageSpecimen.text_url = `detalle/${item.id}`
			this.imageSpecimen.type = "image"
			this.imageSpecimen.text = `${item.plate} ${item.alias ? "-" : ""} ${item.alias ? item.alias : ""}`
			this.imageSpecimen.url = item.image
			this.imageSpecimen.specimen_id = item.id
		},
	},
}
</script>

<style lang="scss">
.img-icon-specimen {
	margin-right: 0.4rem;
}

.container-text-tree {
	margin-bottom: 0.3rem;
}

.alias {
	/* background: red; */
	color: #8900ee;
	margin-bottom: 0.5rem;
	font-size: 16px;
	font-weight: bolder;
}

.image-specimen-tree {
	/* background: red; */
	position: absolute !important;
	top: -1.9rem;
	left: 1rem;
	height: 60px;
	width: 60px;
	border-radius: 50%;
	object-fit: cover;
}

.card-specimen {
	background: #fff;
	padding: 3rem 1rem 1rem 1rem;
	// border: 0.1px solid #858585;
	// width: 120px;
	width: 100%;
	border-radius: 8px;
	margin-bottom: 1rem;
	position: relative;
	margin-top: 3rem;
	text-align: left;
	margin: 3rem auto 0.5rem auto;
	box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);

	// height: 70px;
	/* border-bottom: 4px solid #8900EE; */
	/* overflow: hidden; */
	margin-right: 2rem;

	&:last-child {
		margin-right: 0;
	}

	.line {
		position: absolute;
		bottom: 0;
		left: 0;
		background: #00e2b7;
		width: 100%;
		height: 6px;
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
	}

	.line-madrilla {
		background: #ff5749 !important;
	}

	.container-cintillos {
		margin-top: 1rem;
		display: flex;
		align-items: flex-start;

		.cintillo {
			height: 30px;
			width: 20px;
			background: red;
			clip-path: polygon(0 0, 100% 0%, 100% 100%, 50% 64%, 0 100%);
			position: relative;
			margin-right: 0.5rem;

			:last-child {
				margin-right: 0;
			}

			span {
				font-weight: bold;
				position: absolute;
				left: 50%;
				translate: -50%;
				color: #fff;
			}
		}
	}
}
</style>
